import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import dayjs from "dayjs";
import { Link } from "react-router-dom";

import MuiLink from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

// Icons
import LocationOn from "@mui/icons-material/LocationOn";
import LinkIcon from "@mui/icons-material/Link";
import CalendarToday from "@mui/icons-material/CalendarToday";

const useStyles = makeStyles()((theme) => ({
  paper: {
    padding: 20,
  },
  profile: {
    padding: 20,
    "& .image-wrapper": {
      textAlign: "center",
      position: "relative",
    },
    "& .profile-image": {
      width: 200,
      height: 200,
      objectFit: "cover",
      maxWidth: "100%",
      borderRadius: "50%",
    },
    "& .profile-details": {
      textAlign: "center",
      "& span, svg": {
        verticalAlign: "middle",
      },
      "& a": {
        color: theme.palette.primary.main,
      },
    },
    "& hr": {
      border: "none",
      margin: "0 0 10px 0",
    },
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function StaticProfile(props) {
  const { classes } = useStyles();
  const {
    profile: { handle, createdAt, imageUrl, firstName, lastName, email },
  } = props;
  return (
    <div>
      <Paper className={classes.Paper}>
        <div className={classes.profile}>
          <div className="image-wrapper">
            <img src={imageUrl} alt="profile" className="profile-image" />
          </div>
          <hr />
          <div className="profile-details">
            <MuiLink
              component={Link}
              to={`/users/${handle}`}
              color="primary"
              variant="h5"
              underline="hover">
              @{handle}
            </MuiLink>
            <hr />
            {/* <Typography variant="body2">{`${firstName} ${lastName}`}</Typography> */}
            <hr />
            {/* <Typography variant="body2">{email}</Typography> */}
          </div>
        </div>
      </Paper>
    </div>
  );
}

StaticProfile.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default StaticProfile;
